import "./style.scss"

import React from 'react'
import { IoSendSharp } from 'react-icons/io5'
import { MdComment } from 'react-icons/md'
import { PLAYER_META } from "@const"
import { PlayerID } from "@types"

interface State {
  text: string
  activeIndex: number
  matches: string[]
  // current Player entities
  // playerEntities: PlayerID[]
}

interface Props {
  existPlayers: PlayerID[]
  onSend?: (text: string) => void
  onUpdatePlayerEntity?: (matches: PlayerID[]) => void
}

export class CommentBox extends React.Component<Props, State> {

  state: Readonly<State> = {
    text: '',
    activeIndex: 0,
    matches: [],
  }

  get namesToSearch() {
    // check player's name
    const { existPlayers } = this.props
    const names = existPlayers
      .map(pId => ({ id: pId, data: PLAYER_META[pId] }))
      .flatMap(({ id, data }) => [{ name: data.ln, id }, { name: data.fn, id }])
    return names
  }

  clean() {
    this.setState({ text: '' })
  }

  triggleUpdatePlayerEntities = () => {
    const names = this.namesToSearch
    const { text, activeIndex, matches } = this.state;
    const toInsert = matches[activeIndex]
    const newText = toInsert ? text.replace(/#([^#]*)$/, `#${toInsert}`) : text

    // check existing
    const playerEntities = Array.from(new Set(names.filter(n => {
      const query = `#${n.name.toLowerCase()}`
      return newText.toLowerCase().match(new RegExp(query, 'g'))
    }).map(n => n.id)))
    this.props.onUpdatePlayerEntity?.(playerEntities)
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    

    const names = this.namesToSearch
    const text = e.target.value;
    const lastIndex = text.search(/#([^#\s]*)$/)
    const query = lastIndex === -1 ? '' : text.slice(lastIndex)
    const matches = query !== '' ? names.filter(n => n.name.toLowerCase().startsWith(query.slice(1).toLowerCase())) : []
    this.setState({
      matches: matches.map(m => m.name),
      text: text,
    }, this.triggleUpdatePlayerEntities);
  }

  onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { text, activeIndex, matches } = this.state;

    switch (event.key) {
      case 'Tab':
      case 'Enter': // Enter key
        if (matches.length) {
          const toInsert = matches[activeIndex]

          this.setState({
            activeIndex: 0,
            matches: [],
            text: text.replace(/#([^#]*)$/, `#${toInsert}`),
          }, this.triggleUpdatePlayerEntities);
          event.stopPropagation()
          event.preventDefault()
        }
        // send
        else if (event.target === event.currentTarget && text.trim() !== '') {
          this.props.onSend?.(text)
        }
        break;
      case 'ArrowUp': // Up arrow
        if (matches.length) {
          event.stopPropagation()
          event.preventDefault()
          this.setState({
            activeIndex: activeIndex >= 1 ? activeIndex - 1 : 0
          }, this.triggleUpdatePlayerEntities);
        }
        break;
      case 'ArrowDown': // Down arrow
        if (matches.length) {
          event.stopPropagation()
          event.preventDefault()
          this.setState({
            activeIndex:
              activeIndex < matches.length - 1
                ? activeIndex + 1
                : matches.length - 1
          }, this.triggleUpdatePlayerEntities);
        }
        break;
      default:
        break;
    }
  }

  render(): React.ReactNode {
    const { text, matches, activeIndex } = this.state

    return <div className="comment-box">
      <div className="control">
        <div className={`dropdown ${matches.length > 0 ? "is-active" : ""}`} style={{ width: '100%' }}>
          <div className="dropdown-trigger" style={{ width: '100%' }}>
            <div className="control has-icons-left has-icons-right">
              <input className="input" type="text"
                placeholder="Any thoughts? Enter to send.."
                value={text}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <span className="icon is-left">
                <MdComment style={{ transform: 'scale(1.5)' }}></MdComment>
              </span>
              <span className="icon is-right">
                <IoSendSharp style={{ transform: 'scale(1.5)' }} />
              </span>
            </div>
          </div>
          <div className="dropdown-menu"
            style={{
              left: `${text.length * 9.5 + 40}px` // hardcode for the text width
            }}
          >
            {matches.length > 0 && (
              <div className="dropdown-content">
                {matches.map((match, index) => (
                  <a
                    className={`dropdown-item ${index === activeIndex ? "is-active" : ""
                      }`}
                    href="/"
                    key={`${match}_${index}`}
                  // onClick={event => this.handleSelection(event, match)}
                  >
                    {match}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  }
}